import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=da1119ae&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1119ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1119ae')) {
      api.createRecord('da1119ae', component.options)
    } else {
      api.reload('da1119ae', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=da1119ae&scoped=true&", function () {
      api.rerender('da1119ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Templates.vue"
export default component.exports